<template>

    <div id="entryExam" class="bg">
        <div class="common-header" @click="goHome">
            {{ mecoName }}职业资格考试模拟作答系统
        </div>
        <div class="common-center">
            <h1 class="num">机位号：<span>{{ mecoSeat }}</span></h1>
        </div>
        <div class="stepContainer step1" v-if="idx == 0">
            <div class="layout">
                <div class="lbox">
                    <div class="ltitle">应试人员登录<span>LOGIN</span></div>
                    <div class="lcnt">
                        <div class="linp"><label>准考证号：</label>
                            <el-input v-model="code" placeholder="请输入准考证号"></el-input>
                        </div>
                        <div class="linp"><label>证件号码：</label>
                            <el-input v-model="idcard" placeholder="请输入证件号码"></el-input>
                        </div>
                        <div class="lbtns">
                            <el-button type="primary" @click="login">登录</el-button>
                            <el-button type="warning" @click="reset">重置</el-button>
                        </div>
                    </div>
                </div>
                <!-- <div class="tip"> 提示：准考证号为：11111111 证件号码为：111111111111111111 </div> -->
            </div>
        </div>

        <div class="stepContainer step2" v-if="idx == 1">
            <div class="layout">
                <div class="lbox">
                    <p class="lnotice"><i class="el-icon-bell"></i> 温馨提示：请仔细核对个人信息，如有错误请联系监考人员!</p>
                    <div class="lcns clearfix">
                        <div class="fl do"><img src="../../../../public/images/touxiang.png"></div>
                        <div class="fl dt">
                            <p class="clearfix"><label class="fl">准考证号：</label><span>11111111</span></p>
                            <p class="clearfix"><label class="fl">姓名：</label><span>m930742868</span></p>
                            <p class="clearfix"><label class="fl">性别：</label><span>X</span></p>
                            <p class="clearfix"><label class="fl">考试科目：</label><span>{{ mecoTitle }}</span>
                            </p>
                            <p class="clearfix"><label class="fl">证件号码：</label><span>111111111111111111</span></p>
                            <p class="clearfix"><label class="fl">座位号：</label><span>{{ mecoSeat }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="lbtns">
                    <el-button type="primary" @click="loginBtn">确认登录</el-button>
                    <el-button type="danger" @click="resetBtn">返回</el-button>
                </div>

            </div>
        </div>

        <div class="footer"></div>
    </div>


</template>

<script>
export default {
    data() {
        return {
            idx: 0,
            code: "11111111",
            idcard: "111111111111111111",
            mecoSeat: "",
            mecoName: sessionStorage.getItem("access-mecoName"),
            mecoTitle: sessionStorage.getItem("access-mecoTitle"),
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        let random = Math.floor(Math.random() * 100);
        this.mecoSeat = random;
        sessionStorage.setItem("access-mecoSeat", random);
    },
    methods: {
        goHome() {
            this.$confirm('确认要退出考试吗？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push("/web/index");
            });
        },

        login() {
            if (this.code == '') {
                alert('请填写准考证号');
                return false;
            }

            if (this.idcard == '') {
                alert('请填写证件号码');
                return false;
            }
            this.idx = 1;
        },

        loginBtn() {
            this.$router.push({
                path: "/doctor/notice",
                query: {
                    paper_id: this.paper_id,
                },
            });
            //this.$router.push("/meco/notice");
        },

        resetBtn() {
            this.idx = 0;
        },


        reset() {
            this.code = "";
            this.idcard = "";
        },

        mycourse() {
            this.$router.push("/meco/login");
        },
    },
};
</script>
<style>
@import "../../../../public/css/doctor.css";

.el-input {
    width: 70% !important;
}

.el-button {
    width: 180px !important;
    color: #fff;
}
</style>
